import React from 'react'
import { useBackAction } from '../hooks/useCheckoutAction'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../index'

/**
 * This is a generic button to get back from previous step on wizard
 * @constructor
 */
export const BackButton = () => {
  const [onBack] = useBackAction()

  const { isCurrentCheckoutStepTheFirstStep, showBackButton } = useCheckoutContext()

  return (
    <ShowIf condition={!isCurrentCheckoutStepTheFirstStep && showBackButton}>
      <BusyButton icon="chevron-left" text="Back" onClick={onBack} />
    </ShowIf>
  )
}
